import React, { useState, useRef, useEffect } from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import {
  CancelContainer,
  SelectWrapper,
  SelectButton,
  SelectText,
  ArrowIcon,
  DropdownMenu,
  OptionButton,
  LabelTitle,
} from './styled'

const CancellationReasonSelector = ({ onChange }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const [selectedReason, setSelectedReason] = useState('')
  const wrapperRef = useRef(null)

  const reasons = [t('cancelReasons.0'), t('cancelReasons.1'), t('cancelReasons.2')]

  const handleSelect = reason => {
    setSelectedReason(reason)
    onChange(reason)
    setIsOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  return (
    <CancelContainer>
      <LabelTitle>{t('cancelReasonSelector.title')}</LabelTitle>

      <SelectWrapper ref={wrapperRef}>
        <SelectButton onClick={() => setIsOpen(!isOpen)}>
          <SelectText $hasValue={!!selectedReason}>
            {selectedReason || t('cancelReasonSelector.placeholder')}
          </SelectText>
          <ArrowIcon $isOpen={isOpen} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
          </ArrowIcon>
        </SelectButton>

        {isOpen && (
          <DropdownMenu>
            {reasons.map((reason, index) => (
              <OptionButton key={index} onClick={() => handleSelect(reason)}>
                {reason}
              </OptionButton>
            ))}
          </DropdownMenu>
        )}
      </SelectWrapper>
    </CancelContainer>
  )
}

CancellationReasonSelector.propTypes = {
  onChange: PropTypes.func,
}

CancellationReasonSelector.defaultProps = {
  onChange: () => {},
}
export default CancellationReasonSelector
